/* eslint-disable react/no-unused-state */
/* eslint-disable react/no-access-state-in-setstate */
/* eslint-disable camelcase */
import React, { Component } from "react";

import {
  CHeader,
  CSpinner,
  CButton,
  CInput,
  CModal,
  CModalBody,
  CModalFooter,
  CModalHeader
} from "@coreui/react";
import { FaExclamationCircle } from "react-icons/fa";
import Loadable from "react-loadable";
import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";
import { Redirect, Route, Switch } from "react-router-dom";
import { bindActionCreators } from "redux";

import Banner from "./Banner";
import Header from "./Header";
import NotesSidebar from "./NotesSidebar";
import Sidebar from "./Sidebar";
import { logout, firstLoginDone } from "../actions/baseActions";
import { setLayout } from "../actions/layoutActions";
import { setObj, showHelpdesk, hideHelpdesk } from "../actions/noteActions";
import { profileUpdate, profileGet } from "../actions/profileActions";
import EmotionsModal from "../components/EmotionsModal";
import HelpdeskModal from "../components/HelpdeskModal";
import URL from "../config/api";
import axios from "../config/axios";
import Template from "../template/template";

import "./styles.css";

class Main extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      routes: [],
      banner: false,
      emotionCard: null,
      passwordEdit: false,
      password: "",
      confirmPassword: "",
      parents: [],
      user: {},
      firstLogin: props.user.first_login
    };
  }

  Loading = () => (
    <div className="d-flex w-100 justify-content-center">
      <CSpinner color="secondary" size="sm" />
    </div>
  );

  UNSAFE_componentWillMount() {
    try {
      let routes = this.props.general.routes
        .map(menu => {
          try {
            let component = Loadable({
              loader: () => import(`../pages/${menu.local}`),
              loading: this.Loading
            });

            const { defaultProps } = require(`../pages/${menu.local}`).default
              .WrappedComponent;

            return {
              path: menu.path,
              name: menu.name,
              component,
              exact: menu.exact,
              id: menu.id,
              hideLayout: defaultProps?.hideLayout || false,
              hideContainer: defaultProps?.hideContainer || false
            };
          } catch (err) {
            return {
              path: "./Dashboard",
              name: menu.name,
              component: <Redirect to="/" />,
              exact: menu.exact,
              id: menu.id,
              hideLayout: false,
              hideContainer: false
            };
          }
        })
        .filter(route => route.hideLayout === false);

      this.setState({ routes });
      this.setState({
        passwordEdit:
          this.state.firstLogin &&
          this.props.user.user_roles[0].role_id !== 7 &&
          this.props.user.user_roles[0].role_id !== 9
            ? this.state.firstLogin
            : false
      });
    } catch (err) {
      this.props.logout();
    }
  }

  passwordToggle() {
    if (this.state.passwordEdit) {
      this.setState({ passwordEdit: false, firstLogin: false }, () => {
        this.props.firstLoginDone();
      });
    } else {
      this.setState(() => ({ send: true }));
      this.setState(() => ({ passwordEdit: true }));
    }
    this.forceUpdate();
  }

  passwordEdit() {
    if (this.state.password.length < 8) {
      toastr.error(
        "A senha precisa de pelo menos 8 caracteres",
        "Digite novamente"
      );
      return;
    }

    if (this.state.password === this.state.confirmPassword) {
      this.updateProfile();
      this.passwordToggle();
    } else {
      toastr.error("As senhas não são iguais", "Digite novamente");
    }
  }

  updateProfile() {
    let { user } = this.state;
    user = { ...user, password: this.state.password };

    this.props.profileUpdate(
      user,
      this.state.user_complement,
      () => {
        toastr.success("Sucesso", "Perfil editado com sucesso!");
      },
      this.state.parents.map(parent => parent.id)
    );
  }

  componentDidMount() {
    const get = this.props.user.user.id;
    this.props.setObj(20, get, this.props.currentRoute);

    this.props.profileGet(get, this.props.user.token, user => {
      this.setState(() => ({
        user: user.user,
        user_complement: user.user_complement,
        parents: user.user_parent.map(user => user.parent)
      }));
    });
    let groupId = this.props.general.active_roles.group_id;
    this.props.setLayout(true);

    if (this.state.routes.length > 0) {
      this.setState({
        loading: false
      });
    }

    if (groupId !== null && this.props.user.user_roles[0]?.role_id === 7) {
      if (this.props?.user.emotions === false) {
        this.setState({ emotionCard: false });
      } else {
        axios
          .get(`${URL.api}access/group/singleView/${groupId}`, {
            headers: { authorization: `Bearer ${this.props.user.token}` }
          })
          .then(respgroup => {
            if (respgroup?.data?.data?.group.emotion_card) {
              axios
                .get(`${URL.api}access/user_emotion/today`, {
                  headers: { authorization: `Bearer ${this.props.user.token}` }
                })
                .then(resptoday => {
                  this.setState({
                    emotionCard: resptoday.data.data === null
                  });
                });
            }
          });
      }
    }

    window.banner = () => this.setState({ banner: true });

    // ----------------- SOCKET MARVIN INÍCIO -------------------
    /* let data = {
      //id: this.props.user.user.id,
      //name: this.props.user.user.username
      id: 7,
      name: 'Nome Usuário'
    }

    const { endpoint } = this.state;
    const socket = socketIOClient(endpoint);

    this.setState({
      socket
    }, () => {
      // --------------------- AVISA AO SERVER QUE CONECTOU -------------
      this.state.socket.emit('userConected', data);

      // --------------------- ENVIA OBJ PARA O USUÁRIO 7 NA 'PORTA' notification -------------
      let obj = {
        user_id: 7,
        type: 'notification',
        message: {
          title: 'Título notificação',
          message: 'Mensagem notificação'
        },
        sendTo: [7]
      }
      this.state.socket.emit('socket', obj);
    })

    // --------------------- RECEVE DATA NA 'PORTA' notification -------------
    socket.on("notification", data => {
    }); */
    // ----------------- SOCKET MARVIN FIM -------------------
  }

  render() {
    const { banner } = this.state;
    let isAlagoasStudent =
      (this.props.general.active_roles.group_id === 49 ||
        this.props.general.active_roles.group_id === 86) &&
      this.props.general.active_roles.role_id === 7;

    return (
      <div className={`app${banner ? " banner" : ""}`}>
        {this.props.note?.showHelpdesk && (
          <HelpdeskModal
            show={this.props.note.showHelpdesk}
            base64image={this.props.note.base64image}
            onClose={() => this.props.hideHelpdesk()}
          />
        )}
        {banner && <Banner onClick={() => this.setState({ banner: false })} />}
        {!this.state.loading && (
          <React.Fragment>
            <Template />
            <div className="c-app c-default-layout">
              <Sidebar />
              <NotesSidebar />
              <div className="c-wrapper">
                <CHeader
                  style={{
                    height: "60px",
                    flexWrap: "nowrap",
                    overflowWrap: "anywhere"
                  }}
                >
                  <Header />
                </CHeader>
                <div className="c-body">
                  <main className="c-main p-0">
                    <Switch>
                      {this.state.routes.map((route, idx) => (
                        <Route
                          key={idx}
                          path={route.path}
                          exact={route.exact}
                          name={route.name}
                          render={props => (
                            <div
                              className={
                                route.hideContainer
                                  ? "d-flex flex-column"
                                  : "container-fluid d-flex flex-column pt-4"
                              }
                              style={{
                                minHeight: "100%",
                                padding: route.hideContainer ? "0" : "0 5%"
                              }}
                            >
                              <route.component
                                currentRoute={route.id}
                                {...props}
                              />
                            </div>
                          )}
                        />
                      ))}
                      <Redirect from="/" to="/dashboard" />
                    </Switch>
                  </main>
                  {isAlagoasStudent && (
                    <footer>
                      <div className="helper-layout-modal">
                        <FaExclamationCircle
                          size={40}
                          color="#02517D"
                          onClick={() => this.props.history.push(`/requests`)}
                        />
                      </div>
                    </footer>
                  )}
                </div>
              </div>
            </div>
          </React.Fragment>
        )}
        {this.state.emotionCard === true &&
          this.state.passwordEdit === false && <EmotionsModal />}
        {/* <CModal
          show={this.state.passwordEdit}
          onClose={() => this.passwordToggle()}
          centered
          closeOnBackdrop={false}
        >
          <CModalHeader closeButton={false}>Editar senha</CModalHeader>
          <CModalBody>
            <CInput
              type="password"
              placeholder="Digite uma nova senha"
              className="mb-3"
              value={this.state.password}
              onChange={e => this.setState({ password: e.target.value })}
            />
            <CInput
              type="password"
              placeholder="Digite sua nova senha novamente"
              value={this.state.confirmPassword}
              onChange={e => this.setState({ confirmPassword: e.target.value })}
            />
          </CModalBody>
          <CModalFooter>
            <CButton
              color="primary"
              onClick={() => (
                this.passwordEdit(), this.setState({ savePassword: true })
              )}
            >
              Salvar
            </CButton>
          </CModalFooter>
        </CModal> */}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  layout: state.layout,
  note: state.note
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      setLayout,
      logout,
      showHelpdesk,
      hideHelpdesk,
      profileUpdate,
      profileGet,
      setObj,
      firstLoginDone
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(Main);
